import { NavLink, useLocation } from "react-router-dom";
import { Flame, LayoutGrid, User } from "lucide-react";

const items = [
  { to: "/", label: "Oggi", icon: Flame, testid: "nav-today" },
  { to: "/program", label: "Programma", icon: LayoutGrid, testid: "nav-program" },
  { to: "/profile", label: "Profilo", icon: User, testid: "nav-profile" },
];

export function Layout({ children }) {
  const location = useLocation();
  return (
    <div className="App">
      <div className="relative mx-auto w-full max-w-md min-h-screen flex flex-col bg-[#0a0a0a]">
        <main className="flex-1 pb-safe">{children}</main>

        <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md border-t border-zinc-800 bg-[#0a0a0a]/90 backdrop-blur-md nav-safe z-40">
          <div className="grid grid-cols-3">
            {items.map(({ to, label, icon: Icon, testid }) => {
              const active =
                to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);
              return (
                <NavLink
                  key={to}
                  to={to}
                  data-testid={testid}
                  className="relative flex flex-col items-center justify-center gap-1 py-3"
                >
                  {active && <span className="absolute top-0 h-0.5 w-10 bg-[#fa003f]" />}
                  <Icon size={22} className={active ? "text-[#fa003f]" : "text-zinc-500"} />
                  <span
                    className={`text-[10px] font-bold uppercase tracking-wider ${
                      active ? "text-white" : "text-zinc-500"
                    }`}
                  >
                    {label}
                  </span>
                </NavLink>
              );
            })}
          </div>
        </nav>
      </div>
    </div>
  );
}
